<template>
  <div>
    <v-card class="pa-6 mt-3">
      <v-card-title>
        Add Reward
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text class="text--primary mt-6">

        <AlertMessage :alerMessage="alerMessage"></AlertMessage>

        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <form
            v-on:submit.prevent>
            <v-row class="pa-0">
              <v-col cols="12">
                <ValidationProvider v-slot="{ errors }" name="Amount" rules="required|max:100">
                  <v-text-field
                    v-model="reward.amount"
                    maxlength="100"
                    :error-messages="errors"
                    label="Amount"
                    type="number"
                    required
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="reward.ref_no"
                  maxlength="100"
                  label="Reference No."
                  required
                ></v-text-field>
              </v-col>
              <v-card-title class="px-0 py-0">
                <div v-if="file_upload">
                  <v-chip prepend-icon="mdi-file">
                    {{ file_upload.name }}
                  </v-chip>
                  <v-icon
                    color="red darken-2"
                    @click="deleteImg()">
                    mdi-close
                  </v-icon>
                </div>
                <div v-else class="">
                  <v-chip
                    text-color="white"                    
                    @click="clickFile()"
                    color="primary">
                    <v-icon small left>
                      mdi-image-plus
                    </v-icon>
                    <strong>Upload Proof of Payment</strong>
                  </v-chip>
                  <input v-show="false" type="file" id="file" ref="fileupload" v-on:change="onChangeFileUpload($event)" accept="image/png, image/jpeg, image/jpg"/>
                </div>

              </v-card-title>
            </v-row>
            <v-btn class="d-none" @click="reset"></v-btn>
          </form>
        </ValidationObserver>

      </v-card-text>
      <v-card-actions class="mt-6">
        <v-btn
          color="primary mr-2"
          depressed
          large
          @click="submit">
          <span class="mx-4">
            {{ loading ? 'Please wait...' : '' }}
            {{ !loading ? 'Add Reward' : '' }}
          </span>
        </v-btn>
        <v-btn
          depressed
          large
          @click="cancelReward()">
          <span class="mx-4">Cancel</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import { required, email, max } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import AlertMessage from '@/components/AlertMessage.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  export default {
    name: 'addReward',
    props: ['addRewardDialog'],
    data: () => ({
      accountingNamespace: 'accounting',
      loading: false,
      file:null,
      file_upload: '',
      reward: {
        amount: '',
        ref_no: '',
        file_name: ''
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      headers: [
        {
          text: 'Shipping Mark',
          align: 'start',
          value: 'shipping_mark',
          sortable: false,
          width: 200
        },
        {
          text: 'Description',
          align: 'start',
          value: 'item_description',
          sortable: false,
        },
        {
          text: 'Qty',
          align: 'start',
          value: 'qty',
          sortable: false,
        }
      ]
    }),
    watch: {
      forDeliveryDialog: {
        handler () {
          this.getItems()
        },
        deep: true
      },
    },
    methods: {
      deleteImg () {
        this.reward.file = ''
        this.file_upload = ''
      },
      addAllSelectedItems() {
        this.forDeliveryDialog.show = false
        this.$emit('selectItem', this.selected)
      },
      clickFile() {
        let file = document.getElementById('file');
        file.click()
      },
      onChangeFileUpload(e){
        var files = e.target.files || e.dataTransfer.files;
        this.file_upload = files[0]
      },
      reset() {
        Object.keys(this.reward).forEach(key => {
          this.reward[key] = ''
        })

        this.$refs.observer.reset()
        this.file_upload = ''
      },
      cancelReward() {
        this.reset()
        this.addRewardDialog.show = false
      },
      addNew () {
        let self = this

        let formData = new FormData();

        formData.append('ref_no', this.reward.ref_no);
        formData.append('amount', this.reward.amount);

        if (this.file_upload) {
          formData.append('file', this.file_upload);
        }

        formData.append('client_id', this.addRewardDialog.client_id);

        this.$http.secured.post(this.accountingNamespace+'/rewards',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.$emit('rewardAdded')
            this.reset()
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.alerMessage.messages = ['Something went wrong! Please try again.']
              this.alerMessage.show = true
            }
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
      },
      update () {
        let self = this
        delete this.location['id']

        this.$http.secured.put(this.accountingNamespace+'/rewards/'+this.id, this.location)
          .then(response => {
            this.showMessage(response.data.name + " has been successfully updated", 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })

      },
      async submit () {

        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return false;
        }

        if(this.loading){
          return false;
        }

        this.loading = true

        if(this.forUpdate){
          this.update()
        }else{
          this.addNew()
        }
      }
    },
    mounted() {
    },
    components: {
      AlertMessage,
      ValidationProvider,
      ValidationObserver
    }
  }
</script>
